import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import Hero from '../components/Hero';
import DailyReadings from '../components/DailyReadings';
import VaticanNews from '../components/VaticanNews';
import Testimonials from '../components/Testimonials';
import BeninCultureSection from '../components/BeninCultureSection';
import InscriptionModal from '../components/InscriptionModal';
import ContactModal from '../components/ContactModal';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RoleTestPanel from '../components/RoleTestPanel';

const Home = () => {
  const [isInscriptionModalOpen, setIsInscriptionModalOpen] = React.useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = React.useState(false);

  const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => setIsContactModalOpen(false);

  return (
    <div className="home-page">
       {/* Header */}
        <Header openContactModal={openContactModal} />
      {/* Section Hero principale */}
      <Hero openModal={() => setIsInscriptionModalOpen(true)} />
      
      {/* Section Lectures du jour */}
      <section id="lectures">
        <DailyReadings />
      </section>
      
      {/* Section Actualités du Vatican */}
      <section id="vatican-news">
        <VaticanNews />
      </section>
      
      {/* Section Témoignages */}
      <section id="temoignages">
        <Testimonials />
      </section>
      
      {/* Section Culture béninoise */}
      {/* <section id="culture-benin">
        <BeninCultureSection />
      </section> */}

      {/* Modal d'inscription */}
      <InscriptionModal 
        isOpen={isInscriptionModalOpen} 
        onClose={() => setIsInscriptionModalOpen(false)} 
      />
      
      {/* Modal de contact */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={closeContactModal} 
      />

      {/* <Link
        to="/7-diners-en-amoureux"
        className="fixed right-4 top-1/2 z-50 -translate-y-1/2 rotate-90 origin-right rounded-full bg-gradient-to-r from-fsf-primary via-fsf-secondary to-fsf-primary px-5 py-3 text-sm font-bold uppercase tracking-[0.2em] text-white shadow-2xl transition hover:scale-105 hover:shadow-orange-300/50"
        aria-label="Accéder à la page 7 Dîners en amoureux"
      >
        <span className="inline-flex items-center gap-2">
          <Heart className="h-4 w-4" />
          7 Dîners
        </span>
      </Link> */}
      <Link
        to="/don"
        className="fixed right-4 top-1/2 z-50 -translate-y-1/2 rotate-90 origin-right rounded-full bg-gradient-to-r from-fsf-primary via-fsf-secondary to-fsf-primary px-5 py-3 text-sm font-bold uppercase tracking-[0.2em] text-white shadow-2xl transition hover:scale-105 hover:shadow-orange-300/50"
        aria-label="Accéder à la page Faire un don"
      >
        <span className="inline-flex items-center gap-2">
          <Heart className="h-4 w-4" />
          
          Faire un don
        </span>
      </Link>
      
       {/* Footer */}
        <Footer />
        
        {/* Panneau de test des rôles (dev seulement) */}
        {/* <RoleTestPanel /> */}
    </div>
  );
};

export default Home;